import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Title = styled.div`
  color: #fff;
  font-weight: bold;
  text-align: center;
  margin-top: 6px;

  @media (max-width: 768px) {
    font-size: 14px;
    margin-right: 10px;
  }
`;

const NavCardSquare = styled.div`
  background: ${({ selected }) => (selected ? '#ffb615' : '#fff')};
  color: #002666;
  font-size: 50px;
  width: 100px;
  height: 100px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;

  @media (max-width: 768px) {
    font-size: 30px;
    width: 85px;
    height: 85px;
  }

  &:hover {
    background: ${({ selected }) => (selected ? '#fff' : '#ffb615')};
  }

  &:hover ~ ${Title} {
    color: ${({ selected }) => (selected ? '#fff' : '#ffb615')};
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  a {
    text-decoration: none;
  }
  @media (max-width: 768px) {
    margin-bottom: 20px;
    }
`;

function CategoryCard({ title, icon, style, href, onClick, selected }) {
  return (
    <Container onClick={onClick} style={style}>
      <Link to={href}>
        <NavCardSquare selected={selected}>
          <i className={icon} />
        </NavCardSquare>
        <Title>{title}</Title>
      </Link>
    </Container>
  );
}

export default CategoryCard;
